export default __webpack_public_path__ + "static/media/unstake-fxf.de6eabab.svg";